<div class="container-fluid">
  <div class="row">
    <div class="col-12 p-4">
      <div class="row">
        <div class="col-12">
          <h1 class="text-{{theme.brightContrast}}">{{ operation }}</h1>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-3">
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="clear(true)">CE</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="clear(false)">C</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="divide()">/</button>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(7)">7</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(8)">8</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(9)">9</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="mult()">*</button>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(4)">4</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(5)">5</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(6)">6</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="minus()">-</button>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(1)">1</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(2)">2</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(3)">3</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="plus()">+</button>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="numb(0)">0</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="dot()">.</button>
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-{{theme.bright}}" (click)="eval()">=</button>
        </div>
      </div>

    </div>
  </div>
</div>